import { IsDefined, IsString } from 'class-validator';

export class LoginByTokenResponse {
    @IsDefined()
    @IsString()
    public accessToken: string;

    @IsDefined()
    @IsString()
    public refreshToken: string;

    constructor(data?: Partial<LoginByTokenResponse>) {
        this.accessToken = data?.accessToken;
        this.refreshToken = data?.refreshToken;
    }
}
